<div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="2%">

  <div fxFlex>
    <h1>Edit your profile data</h1>
    <ng-container *awIsInAnyRole="[roles.admin]">
      <aw-admin-form [admin]="loggedUser"></aw-admin-form>
    </ng-container>
    <ng-container *awIsInAnyRole="[roles.customer]">
      <aw-customer-form [customer]="loggedUser"></aw-customer-form>
    </ng-container>
    <ng-container *awIsInAnyRole="[roles.researcher]">
      <aw-researcher-form [researcher]="loggedUser"></aw-researcher-form>
    </ng-container>
    <ng-container *awIsInAnyRole="[roles.logistic]">
      <aw-logistic-form [logistic]="loggedUser"></aw-logistic-form>
    </ng-container>
    <ng-container *awIsInAnyRole="[roles.tester]">
      <aw-tester-form [tester]="loggedUser"></aw-tester-form>
    </ng-container>
  </div>

  <mat-divider vertical="true"></mat-divider>

  <form [formGroup]="changePasswordForm" fxFlex fxLayout="column">
    <h1>Change your password</h1>

    <mat-form-field>
      <mat-label>Old password</mat-label>
      <input autocomplete="current-password" formControlName="oldPassword" matInput name="old-password" type="password">
      <mat-error *ngIf="changePasswordForm.controls.oldPassword?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>New password</mat-label>
      <input autocomplete="off" formControlName="newPassword" matInput name="new" type="password">
      <mat-error *ngIf="changePasswordForm.controls.newPassword?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
      <mat-error
        *ngIf="!changePasswordForm.controls.newPassword?.errors?.required && changePasswordForm.controls.newPassword?.errors?.minlength">
        Mim length required is {{changePasswordForm.controls.newPassword?.errors?.minlength.requiredLength}} characters
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mb-0">
      <mat-label>New password confirm</mat-label>
      <input autocomplete="off" formControlName="newPasswordConfirm" matInput name="confirm-password" type="password">
      <mat-error *ngIf="changePasswordForm.controls.newPasswordConfirm?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-error *ngIf="
      changePasswordForm.controls.newPasswordConfirm.dirty &&
      !changePasswordForm.controls.newPasswordConfirm?.errors?.required &&
      !changePasswordForm.controls.newPassword?.errors?.required &&
       changePasswordForm.errors?.notSame" class="mb-1">
      Password confirm does not match new password
    </mat-error>

    <ng-container *ngIf="changePasswordForm.controls.newPassword.dirty">
      <small>Password policy:</small>

      <small [ngClass]="{'color-warn': changePasswordForm.controls.newPassword?.errors?.minlength}">
        <i *ngIf="changePasswordForm.controls.newPassword?.errors?.minlength" class="fas fa-exclamation-circle"></i>
        <i *ngIf="!changePasswordForm.controls.newPassword?.errors?.minlength" class="fas fa-check"></i>
        At least {{passwordMinLength}} characters long
      </small>
      <small [ngClass]="{'color-warn': !pwdHasUpper()}">
        <i *ngIf="!pwdHasUpper()" class="fas fa-exclamation-circle"></i>
        <i *ngIf="pwdHasUpper()" class="fas fa-check"></i>
        At least one <strong>uppercase</strong> character
      </small>
      <small [ngClass]="{'color-warn': !pwdHasLower()}">
        <i *ngIf="!pwdHasLower()" class="fas fa-exclamation-circle"></i>
        <i *ngIf="pwdHasLower()" class="fas fa-check"></i>
        At least one <strong>lowercase</strong> character
      </small>
      <small [ngClass]="{'color-warn': !pwdHasDigit()}">
        <i *ngIf="!pwdHasDigit()" class="fas fa-exclamation-circle"></i>
        <i *ngIf="pwdHasDigit()" class="fas fa-check"></i>
        At least one <strong>digit</strong>
      </small>
      <small [ngClass]="{'color-warn': !pwdHasSpecial()}">
        <i *ngIf="!pwdHasSpecial()" class="fas fa-exclamation-circle"></i>
        <i *ngIf="pwdHasSpecial()" class="fas fa-check"></i>
        At least one <strong>special</strong> character
      </small>

    </ng-container>

    <div fxLayout="row" fxLayoutAlign="end">
      <button (click)="changePassword()" [disabled]="
              changePasswordForm.invalid" mat-button>
        Save
      </button>
    </div>
  </form>

</div>